import Close from '@ux/icon/x';
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@ux/button';


const DEFAULT_ARIA_LABELS = {
  close: 'Close modal'
};

/**
 * Representation of a Header in the Dialog.
 */

export default function ModalHeader({ children, onClick, id, ariaLabels = DEFAULT_ARIA_LABELS }) {
  const close = typeof onClick === 'function' && (
    <Button
      aria-label={ ariaLabels.close }
      className='modal-close'
      data-action='close'
      data-dismiss='modal'
      design='stateless'
      onClick={ onClick }
      icon={ <Close /> }
    />
  );

  return (
    <div className='modal-header'>
      {close}
      <h2 className='modal-title' id={ id }>{children}</h2>
    </div>
  );
}

ModalHeader.propTypes = {
  /** Header function to close the modal or boolean to hide it */
  onClick: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]),
  /** aria labels */
  ariaLabels: PropTypes.object,
  /** ID for a11y */
  id: PropTypes.string,
  /** Child elements */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
